import React from "react";

import "../styles/sass/main.scss";

const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <div className="row u-margin-bottom-small" style={{flexDirection: "column"}}>
              <h3 className="heading-tertiary">Contact us</h3>
              <p className="u-margin-bottom-zero">Phone: +1(909) 323-0007</p>
              <p>
                Address: 1360 Valley Vista Dr Ste 203, Diamond Bar, CA 91765
              </p>
        </div>
        <div className="row">
          <div className="col-1-of-2 footer-margin-bottom-zero">
            <div className="footer__navigation">
              <ul className="footer__list">
                <li className="footer__item">
                  <a href="/about-us" className="footer__link">
                    About Us
                  </a>
                </li>
                <li className="footer__item">
                  <a href="#" className="footer__link">
                    Careers
                  </a>
                </li>
                <li className="footer__item">
                  <a href="#" className="footer__link">
                    Privacy policy
                  </a>
                </li>
                <li className="footer__item">
                  <a href="#" className="footer__link">
                    Terms
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-1-of-2">
            <p className="footer__copyright">
              Copyright © 2020 NeoVative Inc. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
